import React, { useEffect, useState } from "react";
import { saasApi } from "../../api/saasApi";
import { formatInrFromPaise } from "../../utils/validation";

export default function PlanManagement() {
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => {
    setLoading(true);
    saasApi.adminPlans().then((res) => setPlans(res.data || [])).finally(() => setLoading(false));
  };

  useEffect(() => { load(); }, []);

  const deactivate = async (id) => {
    await saasApi.deactivatePlan(id);
    load();
  };

  return (
    <div>
      <h1>SaaS Plans</h1>
      {loading ? <p>Loading…</p> : (
        <table className="saas-compare-table">
          <thead>
            <tr><th>Name</th><th>Slug</th><th>Monthly</th><th>Yearly</th><th>Trial</th><th>Active</th><th></th></tr>
          </thead>
          <tbody>
            {plans.map((p) => (
              <tr key={p.id}>
                <td>{p.name}</td>
                <td>{p.slug}</td>
                <td>{formatInrFromPaise(p.monthly_price_paise)}</td>
                <td>{formatInrFromPaise(p.yearly_price_paise)}</td>
                <td>{p.trial_eligible ? `${p.trial_days}d` : "No"}</td>
                <td>{p.is_active ? "Yes" : "No"}</td>
                <td>{p.is_active && <button type="button" className="saas-btn saas-btn--secondary" onClick={() => deactivate(p.id)}>Deactivate</button>}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
